import React from 'react';
import { BaseDialog } from './BaseDialog.js';

export function DrazticFlashDialog(data) {
    return (
        <BaseDialog thumbnail={data.thumbnail} title={data.title} text={data.text}>
            <embed src={data.swf} height="400px" width="400px" />
        </BaseDialog>
    );
}
